import { AnalyticsView } from "../ws7/analytics/AnalyticsView";
import "../ws7/ws7.css";

/** /analytics?by=template|account|artist|song&days=&account=&post= (WS7). */
export function AnalyticsPage() {
  return <AnalyticsView />;
}
